import React from "react";
import { useState } from "react";
// import './AutoCrawlSection.css'
import "../../GlobalCss/SPF/AutoCrawlSection.css"
import { Button, Card, Upload, Spin, message, Empty } from "antd";
import { BaseUrl, jwtToken, UserName } from "../../Repository/BaseRepository";
import { getStatusDumpData, callTimecardsGrid, downloadAutoCrawledFiles } from "../../Repository/TimecardFollowupRepository";
import axios from "axios";
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons"
import { SuccessMessage } from "../../Utils/Utils";

const AutoCrawlSection = ({ statusdata, sendtoParent, autocrawl, frequency, vms, originalData, setOriginalData }) => {
    const [hrSourceFile, setHrSourceFile] = useState([]);
    const autocrawlData = autocrawl;
    const [spin, setSpin] = useState(false)
    const [hrUploader, setHrUploader] = useState("");
    const [dumpLoader, setDumpLoader] = useState(false)

    const callDumpData = async () => {
        try {
            setDumpLoader(true)
            const res = await getStatusDumpData();
            if (res === "success") {
                const response = await callTimecardsGrid();
                if (response != null && response.length > 0) {
                    sendtoParent(response)
                    if ((frequency !== '') && (vms !== '')) {
                        const filteredData = response.filter((item) => ((item.Frequency === frequency) && (item.Portal === vms)));
                        setOriginalData(filteredData)
                    }
                    else if ((frequency === '') && (vms !== '')) {
                        const filteredData = response.filter((item) => (item.Portal === vms));
                        setOriginalData(filteredData)
                    }
                    else if ((frequency !== '') && (vms === '')) {
                        const filteredData = response.filter((item) => (item.Frequency === frequency));
                        setOriginalData(filteredData)
                    }
                    else { setOriginalData(response) }
                    SuccessMessage("Data processed successfully !!")
                }
            }
            setDumpLoader(false)
        }
        catch {
            setDumpLoader(false)
        }
    }

    const handleUpload = async (options) => {
        try {
            setSpin(true)
            const { file, onSuccess, onError } = options;
            const updatedDeductionFile = { file, status: "uploading" }
            const formData = new FormData();
            formData.append("SNFile", file);
            setHrSourceFile([])
            setHrUploader(file.name);
            const response = await axios.post(`${BaseUrl}ClientsActiveList/upload_SNfile?Username=${UserName}`, formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "Access-Control-Allow-Origin": "no-cors",
                        Authorization: `Bearer ${jwtToken}`,
                    },
                })
            if (response.data.statusCode === 200) {
                onSuccess(file)
                message.success(`File uploaded successfully`);
                updatedDeductionFile.status = "done"
                setHrSourceFile([updatedDeductionFile])
                setHrUploader('')
                setSpin(false)
            }
            else {
                onError(file)
                message.error("cannot able to upload");
                updatedDeductionFile.status = "error"
                setHrSourceFile([updatedDeductionFile])
                setHrUploader('')
                setSpin(false)
            }
        }
        catch (error) {
            message.error(`File upload failed`);
            setHrUploader('')
            setSpin(false)
        }
    }
    const itemRender = (originNode, file) => {
        let statusColor;
        if (file.status === "done") {
            statusColor = "green";
        } else if (file.status === "error") {
            statusColor = "#f55451";
        }
        let fileExists = false;
        if (hrSourceFile.length > 0) {
            fileExists = true;
        }
        return <>
            <div style={{ display: "flex", width: 300, alignItems: "center", marginLeft: "10px", marginTop: 20 }}>
                <div style={{ color: statusColor, display: "flex", borderRadius: "4px" }}>{fileExists ?
                    <div>{hrSourceFile[0].file.name} </div> : null}</div>
                <DeleteOutlined onClick={() => setHrSourceFile([])} style={{ marginLeft: 5 }} />
            </div>
        </>;
    };

    const downloadFiles = async () => {
        try {
            const res = await downloadAutoCrawledFiles()
        }
        catch {

        }
    };
    return (
        <>
            <div>
                <div className="vms-processed-div">
                    <div>
                        <label className="autocrawl-labels">Total VMS Processed :</label>
                    </div>
                    <div className="processed-div">
                        <label className="autocrawl-labels">{autocrawlData.VmsCompletedCount ? autocrawlData.VmsCompletedCount : null}</label>
                    </div>
                </div>
                {/* <Button type="submit" className="autocrawl-button" onClick={getAutocrawl}>Auto Crawl</Button> */}
                <div className="vms-processed-div">
                    <div>
                        <label className="autocrawl-labels">Batch Status :</label>
                    </div>
                    <div className="processed-div">
                        <label className="autocrawl-labels">
                            {autocrawlData.BatchLabel ? autocrawlData.BatchLabel : null}
                        </label>
                    </div>
                </div>
                <Button type="submit" className="download-reports" onClick={downloadFiles}><span>Download Auto Crawl Reports</span></Button>
                <div className="failed-client-cards-div">
                    {autocrawlData.InvalidClients ? autocrawlData.InvalidClients.length === 0 ?
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: 150 }}>
                            <Empty description={<span style={{ color: "#003A8C" }}>Hurray! No more invalid clients</span>} /></div> :
                        <div className="grid-container">
                            {autocrawlData.InvalidClients.map((item, index) => (
                                <Card className="cards-styling" key={item.Id}>
                                    <div>
                                        <p className="card-heading"><span style={{ fontWeight: "bold" }}>{item.Vms_Name}</span> | {item.Client_Name}</p>
                                        <p className="card-p">{item.Error_Message}</p>
                                    </div>
                                </Card>
                            ))}
                        </div> : null
                    }
                </div>
                <div className="failed-client-cards-div">
                    {autocrawlData.FailedClients ? autocrawlData.FailedClients.length === 0 ?
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: 150 }}>
                            <Empty description={<span style={{ color: "#003A8C" }}>Hurray! No more failed clients</span>} /></div> :
                        <div>
                            <div><label className="autocrawl-labels">Failed Clients :</label></div>
                            <div className="grid-container">
                                {autocrawlData.FailedClients.map((item, index) => (
                                    <Card className="cards-styling" key={item.Id}>
                                        <div>
                                            <p className="card-heading"><span style={{ fontWeight: "bold" }}>{item}</span></p>
                                            {/* <p className="card-p">{item.Error_Message}</p> */}
                                        </div>
                                    </Card>
                                ))}
                            </div> </div> : null
                    }
                </div>
                <div className="manual-upload-div">
                    <Upload className="manual-upload-file"><UploadOutlined style={{ fontSize: "15px", marginRight: "6px", marginLeft: "8px" }} />Manual Upload</Upload>
                    <Button type="submit" className="consolidate-but">Consolidate Review</Button>
                </div>
                <div className="sn-upload-div">
                    <Upload className="manual-upload-file"
                        name="file"
                        customRequest={handleUpload}
                        itemRender={itemRender}
                        fileList={hrSourceFile}
                        accept=".xls,.xlsx"
                        onRemove={() => setHrSourceFile([])}>
                        <UploadOutlined style={{ fontSize: "15px", marginRight: "6px", marginLeft: "8px" }} />SN DATA Upload</Upload>
                    {spin ? <div className="sn-spinner"> <Spin /> </div> : null}
                    <Button type="submit" className="consolidate-but" loading={dumpLoader} onClick={callDumpData}>Consolidate Review</Button>
                </div>
                {hrUploader.length > 0 ? <div style={{ marginBottom: 2, paddingTop: 4, paddingLeft: 20, color: "rgba(0, 39, 102, 1)", height: 14 }}>{hrUploader}</div> : null}
                <div>
                    {hrSourceFile.length > 0 ? <div style={{ height: 20 }}></div> : null}
                </div>
            </div>
        </>
    )
}
export default AutoCrawlSection;